import { render, staticRenderFns } from "./RiskStatus.vue?vue&type=template&id=45eb6d83&scoped=true"
import script from "./RiskStatus.vue?vue&type=script&lang=js"
export * from "./RiskStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eb6d83",
  null
  
)

export default component.exports